import angular from 'angular'
import moment from 'moment'
import templateUrl from './edit-legal-notice.component.html'

export const EditLegalNoticeComponent = {
    templateUrl,
    controller: EditLegalNoticeController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


export const EditLegalNoticeModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditLegalNotice",
    controller: 'EditLegalNoticeController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

function EditLegalNoticeController($q, utilityService, legalNoticeService, ) {
    'ngInject'

    const vm = this;
    vm.legalNotice;
    vm.$onInit = onInit;
    vm.loaded = false;
    vm.handleSave = handleSave;
    vm.handleCancel = handleCancel;
    vm.validateCreateDate = validateCreateDate;
    vm.validateVersionNumber = validateVersionNumber;

    function onInit() {
        vm.legalNotice = vm.resolve.legalNotice;
        vm.pristineLegalNotice = angular.copy(vm.legalNotice);
    }

    function handleSave() {
        validateCreateDate();
        validateVersionNumber();
        if (vm.editForm.$invalid) {
            return;
        }
        utilityService.showLoading();
        (function () {
            const command = {
                Name: vm.legalNotice.Name,
                HeaderText: vm.legalNotice.HeaderText,
                RequireForSiteAccess: vm.legalNotice.RequireForSiteAccess,
                CreateDate: vm.legalNotice.CurrentLegalNoticeContent.CreateDate,
                VersionNumber: vm.legalNotice.CurrentLegalNoticeContent.VersionNumber,
                NoticeContent: vm.legalNotice.CurrentLegalNoticeContent.NoticeContent
            };
            if (!vm.legalNotice.LegalNoticeID) {
                return legalNoticeService.createLegalNotice(command);
            } else {
                return legalNoticeService.updateLegalNotice(vm.legalNotice.LegalNoticeID, command);
            }
        })()
            .then(function () {
                vm.close();
            })
            .catch(function (ex) {
                alert("Saving legal notice failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function validateCreateDate() {
        if (vm.legalNotice.LegalNoticeID) {
            const orignalDate = moment(vm.pristineLegalNotice.CurrentLegalNoticeContent.CreateDate);
            const date = moment(vm.legalNotice.CurrentLegalNoticeContent.CreateDate);
            if (date.isAfter(orignalDate)) {
                vm.editForm.createDate.$setValidity("validCreateDate", true
                );
            } else {
                vm.editForm.createDate.$setValidity("validCreateDate", false);
            }
        }
    }

    function validateVersionNumber() {
        if (vm.legalNotice.LegalNoticeID) {

            if (vm.legalNotice.CurrentLegalNoticeContent.VersionNumber >
                vm.pristineLegalNotice.CurrentLegalNoticeContent.VersionNumber) {
                vm.editForm.versionNumber.$setValidity("validVersionNumber", true);
            } else {
                vm.editForm.versionNumber.$setValidity("validVersionNumber", false);
            }
        }
    }

    function handleCancel() {
        vm.dismiss({ $value: 'cancel' });
    }
}
